<template>
    <p-inc-todo-card
        :item = "item"
    >
        <template v-slot:tag>
            <div class="lgs-state" :class="tagColor" v-if="item.lgsState">
                LGS
            </div>
        </template>
        <template v-slot:comment>
            <div class="v-flex">
                <div class="card-subtitle">
                    {{ format (item.siteDownBegin) }}
                </div>
                <v-spacer/>
                <div class="card-subtitle" :class="textColor()" v-if="item.siteDownBegin">
                    {{ delay }} Tage
                </div>
                <div class="card-subtitle error--text" v-if="!item.siteDownBegin">
                    Beginn des Stillstandes fehlt
                </div>
            </div>
        </template>
    </p-inc-todo-card>
</template>

<script>

import Core             from "@/modules/core/service/Core";
import PIncTodoCard     from "@/modules/inc/todos/components/private/PIncTodoCard.vue";
import IncTodoCardMixin from "@/modules/inc/todos/components/mixins/IncTodoCardMixin";

export default {
    name: "PIncSiteDownCard",

    components: {
        PIncTodoCard
    },

    mixins: [
        IncTodoCardMixin
    ],

    computed: {
        delay () {
            return Core.format.delayInDays(this.item.siteDownBegin);
        },
        tagColor () {
            switch (this.item.lgsState) {
                case "LOST_SIGNAL":
                    return "yellow white--text";
                case "NORMAL":
                    return "success white--text";
                case "LONG_STANDSTILL":
                case "STANDSTILL":
                    return "error white--text"
            }

            return null;
        }
    },

    methods: {
        textColor () {
            if (this.delay >= 7) {
                return "error--text"
            }

            return 'primary--text';
        }
    }
}
</script>

<style scoped>

.card-subtitle {
    font-size: 13px;
}

.lgs-state {
    font-size: 11px;
    margin-left: 4px;
    margin-right: 4px;
    margin-top: 2px;
    height: 18px;
    width: 40px;
    text-align: center;
    padding-top: 1px;
    border-radius: 3px;
}

</style>